import { OtherBrands } from "../../../../utils/brandFilters/sortBrands";
import mostFrequent from "./mostFrequent";

type ThemeType = { id: number; name: string; brandId?: number | null };

// Portada from the most used keg brand, then bottle brand, else multimarca
const pickProposalTheme = (
  kegBrands: number[],
  bottleBrands: number[],
  themes: ThemeType[] | undefined,
): number | undefined => {
  const brands = kegBrands.length ? kegBrands : bottleBrands;
  const mostUsedBrandId = mostFrequent(brands)[0];

  const themeId =
    mostUsedBrandId !== undefined
      ? themes?.find((_) => _.brandId === mostUsedBrandId)?.id
      : undefined;

  return (
    themeId ??
    themes?.find((_) => OtherBrands.includes(_.name.toUpperCase()))?.id
  );
};

export default pickProposalTheme;
